export default __webpack_public_path__ + "static/media/Five_Pointed_Star_Solid.bb5d8d0e.svg";